//
export const BUCKET_FUNDS = "funds";
export const BUCKET_ORGS = "agbase_orgs";
export const BUCKET_DEALS = "agbase_deals";
export const BUCKET_COUNTRIES = "countries";
export const BUCKET_SECTORS = "sectors";
export const BUCKET_AGBASE_CATEGORIES = "agbase_categories";
export const BUCKET_AGBASE_VALUECHAIN = "agbase_value_chains";
export const BUCKET_MEDIA_MENTIONS = "media_mentions";
